import React, { Component } from "react";

import { Row, Col, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";

import avatar1 from "../../assets/images/users/avatar-1.jpg";
import profileImg from "../../assets/images/profile-img.png";

class WelcomeComp extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
 
    render() {
        let authUser =  JSON.parse(localStorage.getItem("authUser"));
        let client = authUser.data.Company.name;
        let user = authUser.data.user.name;
        let dashboardData = this.props.dashboardDataE;

        return (
            <React.Fragment>
                <Card className="overflow-hidden">
                    <div className="bg-soft-primary">
                        <Row>
                            <Col xs="7">
                                <div className="text-primary p-3">
                                    <h5 className="text-primary">Welcome Back !</h5>
                                    <p>Linn Ticket Dashboard</p>
                                </div>
                            </Col>
                            <Col xs="5" className="align-self-end">
                                <img src={profileImg} alt="" className="img-fluid" />
                            </Col>
                        </Row>
                    </div>
                    <CardBody className="pt-0">
                        <Row>
                            <Col sm="4">
                                <div className="avatar-md profile-user-wid mb-4">
                                    <img src={avatar1} alt="" className="img-thumbnail rounded-circle" />
                                </div>
                                <h5 className="font-size-15 text-truncate">{user}</h5>
                                {/* <p className="text-muted mb-0 text-truncate">UI/UX Designer</p> */}
                            </Col>

                            <Col sm="8">
                                <div className="pt-4">
                                    <Row>
                                        <Col xs="6">
                                            <h5 className="font-size-15">{dashboardData.total_customer}</h5>
                                            <p className="text-muted mb-0">Customer</p>
                                        </Col>
                                        <Col xs="6">
                                            <h5 className="font-size-15">{dashboardData.total_vehicle}</h5>
                                            <p className="text-muted mb-0">Vehicle</p>
                                        </Col>
                                    </Row>
                                    <div className="mt-4">
                                        <Link to="/profile" className="btn btn-primary waves-effect waves-light btn-sm">View Profile <i className="mdi mdi-arrow-right ml-1"></i></Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </React.Fragment>
        );
    }
}

export default WelcomeComp;
